const PropTypes = require('prop-types');
const React = require('react');
const PackageInputs = require('./package_inputs');
const ShippingProtectionInputContainer = require('./containers/shipping_protection_input_container');
const SignatureRequiredInputContainer = require('./containers/signature_required_input_container');
const MediaMailInputContainer = require('./containers/media_mail_input_container');

function Details(props) {
  return (
    <div>
      <div className="module bd-rounded mb-2">
        <h3 className="heading-3 mb-1">
          {I18n.t('js.dashboard.selling.shippingLabels.details.shipmentDetailsTitle')}
        </h3>
        <PackageInputs
          package={props.package}
        />
      </div>
      <div className="module bd-rounded mb-2">
        <h3 className="heading-3 mb-1">
          {I18n.t('js.dashboard.selling.shippingLabels.details.shipmentOptionsTitle')}
        </h3>
        <ShippingProtectionInputContainer />
        <SignatureRequiredInputContainer />
        <MediaMailInputContainer />
      </div>
    </div>
  );
}

Details.propTypes = {
  package: PropTypes.object.isRequired,
};

module.exports = Details;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/details.jsx